var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.placeContext)?_c('div',[(1 == _vm.$route.query.hl)?_c('header',{staticClass:"container text-center mt-3 mb-5"},[_c('img',{staticClass:"img-fluid",attrs:{"src":_vm.placeContext.logo_path}})]):_vm._e(),_c('router-view')],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }